import { apiPost } from './apiService';

export interface PatientCase {
  id: string;
  correctDiagnosis: string;
  acceptableAlternatives: string[];
  initialPresentation: string;
  patientHistory: string;
  additionalSymptoms: string[];
  availableExams: string[];
  explanation: string;
  periodStart: string;
}

export interface AiResponse {
  responseType: 'chat' | 'exam' | 'diagnosis' | 'error';
  content: string;
}

export interface DiagnosisResult {
  isCorrect: boolean;
  confidence: number;
}

class AIService {
  async generatePatientCase(specialty: string, rarity: string): Promise<PatientCase> {
    return apiPost<PatientCase>('/ai/generate-case', { specialty, rarity });
  }

  async generateResponse(
    userInput: string,
    caseJson: string,
    historyJson: string,
  ): Promise<AiResponse> {
    return apiPost<AiResponse>('/ai/process-input', { userInput, caseJson, historyJson });
  }

  async checkDiagnosis(diagnosis: string, caseJson: string): Promise<DiagnosisResult> {
    return apiPost<DiagnosisResult>('/ai/check-diagnosis', { diagnosis, caseJson });
  }

  async markDiagnosisComplete(specialty: string, diagnosis: string, periodStart: string): Promise<void> {
    await apiPost('/ai/mark-diagnosis-complete', { specialty, diagnosis, periodStart });
  }

  async submitFeedback(comment: string, chatHistory: string, caseJson: string): Promise<void> {
    await apiPost('/ai/submit-feedback', { comment, chatHistory, caseJson });
  }
}

export const aiService = new AIService();
